export const loadingData = [
  {
    status: "mint",
    text: [
      "Gathering pixels for your collection...",
      "Convincing the TON blockchain to accept your contract...",
      "Deploying programmer cats for the final review...",
      "Ghosts of the internet approve your creation...",
      "No going back now. The chain remembers.",
      "Folding reality into a token...",
      "Injecting soul into digital matter...",
      "Locking your vision into digital eternity...",
      "Binding image and code into one story...",
      "Assembling digital threads into a single canvas...",
      "Syncing your pixels with the rhythm of the chain...",
      "Summoning digital hamsters to spin the wheels...",
      "Deploying programmer cats for the final review...",
      "Ghosts of the internet approve your creation...",
      "No going back now. The chain remembers.",
      "Folding reality into a token...",
      "Injecting soul into digital matter...",
    ],
  },
  {
    status: "createCollection",
    text: [
      "Gathering pixels for your collection...",
      "Convincing the TON blockchain to accept your contract...",
      "Deploying programmer cats for the final review...",
      "Ghosts of the internet approve your creation...",
      "No going back now. The chain remembers.",
      "Folding reality into a token...",
      "Injecting soul into digital matter...",
      "Locking your vision into digital eternity...",
      "Binding image and code into one story...",
      "Assembling digital threads into a single canvas...",
      "Syncing your pixels with the rhythm of the chain...",
      "Summoning digital hamsters to spin the wheels...",
      "Deploying programmer cats for the final review...",
      "Ghosts of the internet approve your creation...",
      "No going back now. The chain remembers.",
      "Folding reality into a token...",
      "Injecting soul into digital matter...",
    ],
  },
  {
    status: "loading",
    text: ["Loading..."],
  },
];
